function onExperienceEvent(name, epid) {
    onExperienceEvents(name, [epid]);
}
function onExperienceEvents(name, epids) {
    if (axios) {
        var events = [];
        for (var i = 0; i < epids.length; i++) {
            var epid = epids[i];
            events.push({
                client: 'website',
                experienceId: epid,
                eventName: name,
            });
        }


        axios.post('/analytics/OnExperienceEvents', events);
    }
}